module.exports = __webpack_public_path__ + "img/cp-bg.8091ce83.png";